module.exports = __webpack_public_path__ + "static/media/김지윤.972a26f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/person/김지윤.png
// module id = 100
// module chunks = 0